import * as React from 'react';
import { useEffect } from 'react';
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsLoggedIn } from './UserSlice';
import { LOGIN, PROFILE } from '../../routes/CONSTANTS';
import { Auth } from 'aws-amplify';
import { setUser, resetUser } from '../auth/UserSlice';
import { resetSubscription } from '../subscription/SubscriptionSlice';
import { handleFetchSubscriptionDetails } from '../subscription/SubscriptionService';
import { store } from '../../app/store';

export default function RequireAuth({ children }) {
  const navigate = useNavigate();
  const loggedIn = useSelector(selectIsLoggedIn);
  const location = useLocation();

  useEffect(() => {
    //Restore redux store data after page refresh if the auth
    //session is still valid.
    Auth.currentAuthenticatedUser()
      .then((user) => {
        if (user) {
          const formattedUser = {
            sub: user.attributes.sub,
            firstName: user.attributes.given_name,
            lastName: user.attributes.family_name,
            email: user.attributes.email,
            emailVerified: user.attributes.email_verified,
          };
          store.dispatch(setUser(formattedUser));
          handleFetchSubscriptionDetails();
          if (formattedUser.emailVerified !== true) {
            if (location.pathname !== PROFILE) {
              navigate(PROFILE);
            }
          }
        }
      })
      .catch(() => {
        store.dispatch(resetUser());
        store.dispatch(resetSubscription());
      });
  });

  if (!loggedIn) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to={LOGIN} state={{ from: location }} replace />;
  } else {
    return children;
  }
}
